import { Skeleton } from '@material-ui/lab';
import React from 'react';

export const SideBarYourImpactSkeleton = () => {
  return <Skeleton variant='text' width='100%' height={180} />;
};
